// @ts-nocheck

import React from 'react';
import { navigate } from '../../lib/routerAdapter';
import { tripInspectionCostApi } from './../../lib/api';
import CommonListPage from './../../components/hoc/common/handbook/ListPage';
import Page from '../../components/hoc/common/handbook/PageContext';
import { withUserAccess } from './../withUserAccess';

import { Filter } from './components';
import { formatDateTimeToString } from '../../lib/helpers';
import { getBreadCrumbsByUrl } from '../../lib/autoBreadcrumbs';
import { approveTypes } from '../../lib/enum';

const entryPointPath = '/admin/trip-inspection-cost/';

const columns = [
{
  title: 'Филиал',
  dataIndex: 'orgUnitName'
},
{
  title: 'Стоимость одного осмотра без НДС, руб',
  dataIndex: 'cost'
},
{
  title: 'Дата начала',
  dataIndex: 'startDate',
  render: (startDate) =>
  formatDateTimeToString(startDate, 'DD.MM.YYYY')
},
{
  title: 'Дата окончания',
  dataIndex: 'endDate',
  render: (endDate) => formatDateTimeToString(endDate, 'DD.MM.YYYY')
},
{
  title: 'Статус',
  dataIndex: 'status',
  render: (status) => approveTypes[status]
}];


const breadCrumbs = getBreadCrumbsByUrl(entryPointPath);

const access = {
  add: () => navigate(`${entryPointPath}new`)
};

export default withUserAccess(({ userAccess }) => {
  return (
    <Page>
      <CommonListPage
        crud={tripInspectionCostApi}
        pageHeaderProps={{
          breadCrumbs,
          mainHeader: 'Стоимость предрейсовых/послерейсовых осмотров',
          access
        }}
        tableListProps={{
          columns,
          onSelect: (id) => navigate(`${entryPointPath}${id}`),
          canDelete: true
        }}
        filter={Filter} />

    </Page>);

});